import { useState } from 'react'
import { getErrorMessage } from '../../api/client'
import type { EdgeConfigResult } from '../../types'

// 엣지 설정 다이얼로그 공통 — 입력칸 모양·제출 흐름 (컴포넌트는 MasterGroupDialogs)

export const inputClass = 'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-50 disabled:text-gray-500'

// 저장 버튼 + 오류 — 공통 제출 흐름
export function useSubmit(onDone: (result: EdgeConfigResult) => void) {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const submit = async (call: () => Promise<{ data: EdgeConfigResult }>) => {
    setSaving(true)
    setError(null)
    try {
      const { data } = await call()
      onDone(data)
    } catch (err) {
      setError(getErrorMessage(err, '저장하지 못했습니다.'))
      setSaving(false)
    }
  }
  return { saving, error, submit }
}
